module.exports = __webpack_public_path__ + "img/logo-SSP-tmp.fcca0c51.svg";